<template>
  <div>
    <div class="page-header header-filter bg-3">
      <b-container>
        <b-row>
          <b-col>
            <h1>Your Account: {{ playerName }}</h1>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div>
      <b-container>
        <b-row>
          <b-col>
            <h3>Authorising Strava connection...</h3>
          </b-col>
        </b-row>
        <b-row>
          <b-col><b-spinner variant="primary" type="border"></b-spinner></b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { BSpinner } from "bootstrap-vue"
import client from "../strava-client";

const { mapState, mapActions } = createNamespacedHelpers("session");

export default {
  name: "StravaAuth",
  components: {
    BSpinner
  },
  async created() {
    // Get auth code from url
    // ?state=&code=dfa49de082589b0f49760067540dab25ad9bc892&scope=read,activity:write
    // Call Strava api to exchange code for tokens

    console.log(`Window loc: ${window.location.href}`);
    console.log(`Q: ${JSON.stringify(this.$route.query)}`);

    const tokenRes = await client.fetchTokens(this.$route.query.code);
    console.log(JSON.stringify(tokenRes));

    // Store tokens etc on server
    await this.updateStrava({
      scope: this.$route.query.scope,
      accessToken: tokenRes.data.access_token,
      refreshToken: tokenRes.data.refresh_token,
      expiry: tokenRes.data.expires_at,
    });
  },
  computed: {
    ...mapState({
      player: "player",
      playerName() {
        return this.player && this.player.name;
      },
    }),
  },
  methods: {
    ...mapActions(["updateStrava"]),
  },
  destroyed() {
  },
};
</script>

<style scoped>
.page-header {
  height: auto;
  padding-top: 100px;
  padding-bottom: 50px;
}
</style>